import { Component, computed, inject, input, signal, viewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControl, FormControlDirective, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';

@Component({
    selector: 'baas-boolean-list',
    templateUrl: './baas-boolean-list.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BaasBooleanList,
            multi: true
        }
    ],
    imports: [MatRadioModule, ReactiveFormsModule]
})
export class BaasBooleanList implements ControlValueAccessor {
    readonly #controlContainer = inject(ControlContainer, { optional: true });
    readonly formControlDirective = viewChild.required(FormControlDirective);
    /** Whether also undefined state (true by default) */
    readonly tristate = input(true);
    readonly trueLabel = input('Ja');
    readonly falseLabel = input('Neen');
    readonly undefinedLabel = input('Onbepaald');
    readonly _formControl = input<FormControl>(undefined, { alias: 'formControl' });
    readonly formControlName = input<string>(undefined);
    protected readonly disabled = signal<boolean>(undefined);
    protected readonly formControl = computed(() => {
        if (this._formControl()) return this._formControl();
        if (this.formControlName && this.#controlContainer) return <FormControl>this.#controlContainer.control.get(this.formControlName());
        return undefined;
    });

    writeValue(value: boolean | null): void {
        this.formControlDirective().valueAccessor.writeValue(value);
    }

    registerOnChange(fn: any): void {
        this.formControlDirective().valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any): void {
        this.formControlDirective().valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean): void {
        this.formControlDirective().valueAccessor.setDisabledState(isDisabled);
    }
}
